import { pillCategoriesList } from "../../api/HttpApis";
import Button from "../../component/button/Button";

export const getPillCategoriesList = async (page, perpage) => {
  const response = await pillCategoriesList({}, perpage, page);
  const data = Array.isArray(response?.data?.data) ? response.data.data : [];

  return data?.map((item) => ({
    id: item.id,
    CategoryTitle: item.name,
    status: item.status,
    buttonText: "Edit",
    buttonText2: "Remove",
    totalCount: response?.data?.total || 0,
  }));
};

export const getColumns = (handleEdit, handleDelete, deletingId) => [
  { key: "CategoryTitle", label: "Category Title" },
  { key: "status", label: "Status" },
  {
    key: "buttonText",
    render: (item) => (
      <Button onClick={() => handleEdit(item.id)}>{item.buttonText}</Button>
    ),
  },
  {
    key: "buttonText2",
    render: (item) => (
      <Button
        onClick={() => handleDelete(item.id)}
        loading={deletingId === item.id}
        disabled={deletingId === item.id}
      >
        {item.buttonText2}
      </Button>
    ),
  },
];
